// Module
var code = "<p> Examen <b>{{service.description}}</b> - <b>{{formatDate service.service_cca.0.date_exam}}</b> </p> <p> Le paiement est 3D secure - Apr&egrave;s avoir saisi votre carte, vous allez recevoir une demande de <b>confirmation de votre banque</b>, pensez à verifier vos SMS. </p> ";
// Exports
export default code;